import { api } from './api';
import type { EvidenciaHistorica } from '@/types/types';

export interface EvidenciaUploadResult {
  nombre: string;
  ok: boolean;
  error?: string;
}

export interface UploadFolderResponse {
  success: boolean;
  total: number;
  exitosos: number;
  fallidos: number;
  resultados: EvidenciaUploadResult[];
}

export const evidenciasService = {
  async upload(nit: string, formData: FormData): Promise<void> {
    await api.postFormData(`/empresas/${nit}/evidencias`, formData);
  },

  async uploadMultiple(nit: string, formData: FormData): Promise<UploadFolderResponse> {
    return api.postFormData<UploadFolderResponse>(`/empresas/${nit}/evidencias`, formData);
  },

  async eliminar(nit: string, evidenciaId: number): Promise<void> {
    await api.delete(`/empresas/${nit}/asesoria-activa/evidencias/${evidenciaId}`);
  },

  async getHistorico(): Promise<EvidenciaHistorica[]> {
    const response = await api.get<{ success: boolean; data: EvidenciaHistorica[] }>('/asesor/mis-evidencias');
    return response.data;
  },

  async solicitarAcceso(evidenciaId: number, email?: string): Promise<{ success: boolean; message: string }> {
    return api.post<{ success: boolean; message: string }>(`/asesor/evidencias/${evidenciaId}/solicitar-acceso`, {
      email: email?.trim() ? email.trim() : undefined,
    });
  },
};
